import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = [] as DeliveryAddress[];

const slice = createSlice({
  name: 'recentLocations',
  initialState,
  reducers: {
    addToRecentLocations(state, action: PayloadAction<DeliveryAddress>) {
      return [action.payload];
    },
    clearRecentLocations(_state) {
      return [];
    },
  },
});

export const { addToRecentLocations, clearRecentLocations } = slice.actions;

export default slice.reducer;
